import React, { Component, Fragment } from "react";
import { inject, observer } from 'mobx-react';
import classnames from "classnames";
import TodoMutation from "./mutateTodo";
import { Image, Menu, Plus, Search, Star, Check, Info, Trash, Edit, Tag  } from "react-feather";
import { 
  Button, Card, CardBody, Col, FormGroup, Input, Row,
  Label, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown
} from "reactstrap";

import Checkbox from "../../theme/@vuexy/checkbox/CheckboxesVuexy";
import Chip from "../../theme/@vuexy/chips/ChipComponent";

@inject('todoStore')
@observer
class Todo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      todoOverlaySlider: false,
      isEditable: false
    }
  }

  componentDidMount = () => {
    const { todoStore } = this.props;
    todoStore.getTodos();
  }

  onChange = event => {
    const { todoStore } = this.props;
    let value = event.target.value;
    if (event.target.name === "title") {
      todoStore.setAttribute(event.target.name, value);
    }
    if (event.target.name === "description") {
      todoStore.setAttribute(event.target.name, value);
    }
  };

  toggleValue = (name, todo) => {
    const { todoStore } = this.props;
    if (name === "isCompleted" || "isImportant" || "isStarred") {
      todoStore.toggleAttributes(name, todo);
    }
  }

  trashTodo = (id) => {
    const { todoStore } = this.props;
    todoStore.moveToBin(id);
  }

  setLabel = (name) => {
    const { todoStore } = this.props;
    todoStore.tagTodo(name);
  }

  handleSave = (todo) => {
    const { todoStore } = this.props;
    todoStore.setTodo(todo);
    todoStore.saveTodo();
    this.toggleOverlay(false);
  }

  // toogle method will take 3 params -> toggle: bool, new/edit: string, data: any
  toggleOverlay = (toggle, action = "", data = false) => {
    const { todoStore } = this.props;
    if (toggle) {
      if (action === "new") {
        todoStore.setBlankTodo();
      }
      if (action === "edit" && data) {
        todoStore.setTodo(data);
      }
    }
    this.setState({
      isEditable: action === "edit" ? true : false,
      todoOverlaySlider: toggle
    });
  }

  renderTodos = () => {
    //Filter todos and eliminate those entries having isTrashed: true
    const { todoStore } = this.props;
    const { todos } = todoStore;
    const routerFilter = "";
    return(
      <div className="todo-application">
        {
          todos.map((todo)=>{
            return(
              <Card key = { todo.uid } className = "mb-1" >
                 <CardBody onClick={() => this.toggleOverlay(true, 'edit', todo)}>
                  <div className={`todo-item ${todo.isCompleted ? "completed" : ""}`}>
                    <div className="todo-title-wrapper d-flex justify-content-between mb-50">
                      <div className="todo-title-area d-flex align-items-center">
                        <div className="title-wrapper d-flex">
                          <Checkbox
                            color="primary"
                            className="user-checkbox"
                            icon={<Check className="vx-icon" size={12} />}
                            label={""}
                            checked={todo.isCompleted}
                            size="sm"
                            value={todo.isCompleted}
                            onClick={e => {
                              e.stopPropagation()
                              this.toggleValue("isCompleted", todo)
                            }}
                            onChange={e => e.stopPropagation()}
                          />
                          <h6 className="todo-title mt-50 mx-50">{todo.title}</h6>
                        </div>
                        {todo.labels.length > 0 ? (
                          <div className="chip-wrapper">
                            {todo.labels.map((tag, i) => (
                              <div className="chip mb-0" key={i}>
                                <div className="chip-body">
                                  <span className="chip-text">
                                    <span
                                      className={`bullet bullet-${
                                        tag === "backend"
                                          ? "warning"
                                          : tag === "doc"
                                            ? "success"
                                            : tag === "bug"
                                              ? "danger"
                                              : "primary"
                                        } bullet-xs`}
                                    />
                                    <span className="text-capitalize ml-25">
                                      {tag}
                                    </span>
                                  </span>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </div>
                      <div
                        className={`todo-item-action d-flex ${
                          routerFilter === "trashed" ? "justify-content-end" : ""
                          }`}
                      >
                        <div
                          className={`todo-item-info d-inline-block ${
                            routerFilter === "trashed" ? "mr-1" : "mr-1 mr-sm-0"
                            }`}
                          name="isImportant"
                          onClick={e => {
                            e.stopPropagation()
                            this.toggleValue("isImportant", todo)
                          }}
                        >
                          <Info
                            size={17}
                            color={todo.isImportant ? "#228B22" : "#333"}
                            className="ml-1"
                          />
                        </div>
                        <div
                          className="todo-item-favorite d-inline-block mr-1 mr-sm-0"
                          name="isStarred"
                          onClick={e => {
                            e.stopPropagation()
                            this.toggleValue("isStarred", todo)
                          }}
                        >
                          <Star
                            size={17}
                            color={todo.isStarred ? "#FFDF00" : "#333"}
                            className="ml-1"
                          />
                        </div>
                        {routerFilter !== "trashed" ? (
                          <div
                            className="todo-item-delete d-inline-block ml-1 mr-1 mr-sm-0"
                            onClick={e => {
                              e.stopPropagation()
                            }}
                          >
                            <Trash onClick={()=>this.trashTodo(todo.uid)} size={17} />
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {
                      todo.description.length > 0
                        ? <p className="todo-desc truncate mb-0">{todo.description}</p>
                        : null
                    }  
                  </div>
                </CardBody>
              </Card>
            );
          })
        }
      </div>
    )
    
  }

  render() {
    const { todoStore } = this.props;
    const { todos, todo } = todoStore;
    const { title, description, isCompleted } = todoStore.todo;
    const { isEditable } = this.state;
    const routerFilter = "";
    return (
      <div className="library-content">
        <Row>
          <Col sm="12">
            <div className="_library-header-items">
              <div className="result-toggler w-25 d-flex align-items-center">
                <div className="library-sidebar-toggler d-block d-lg-none">
                  <Menu
                    size={26}
                    onClick={() => this.props.mainSidebar(!this.props.sidebar)}
                  />
                </div>
                <div className="search-results">{this.state.totalRecords} Results Found</div>
              </div>
              <div className="view-options d-flex justify-content-end w-75">
                <div className="actions-left d-flex flex-wrap view-btn-option">
                  <Button
                    color="primary"
                    className="btn ml-1"
                    onClick={() => this.toggleOverlay(true, "new")}
                    size="md">
                    <Plus size={15} />
                    <span className="align-middle">Add New</span>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col sm="12">
            <div className="_library-searchbar mt-1">
              <FormGroup className="position-relative">
                <Input
                  className="search-product"
                  placeholder="Search Here..."
                />
                <div className="form-control-position">
                  <Search size={22} />
                </div>
              </FormGroup>
            </div>
          </Col>
          <Col sm="12">
            <div id="_library-products">
              {
                todos && todos.length
                ? this.renderTodos()
                : <div className="d-flex justify-content-center mt-5">
                    <p className="text-muted">No pending Todos</p>
                  </div>
              }  
            </div>
          </Col>
        </Row>
        <div className="animation-slider">
          {
            this.state.todoOverlaySlider
              ? <Fragment>
                <TodoMutation 
                  isEditable={isEditable}
                  todo={todo}
                  saveTodo={(todo) => this.handleSave(todo)}
                  closeOverlay={() => this.toggleOverlay(false)}
                />
                <div
                  className={classnames("animation-slider-overlay", {
                    show: this.state.todoOverlaySlider
                  })}
                  onClick={() => this.toggleOverlay(false)}
                />
              </Fragment>
              : null
          }
        </div>
      </div>  
    );
  }
}

export default Todo;



// <Card key={item.uid} className="mb-1">
//   <CardBody onClick={() => this.toggleOverlay(true, 'edit', item)}>
//     <div className="d-flex justify-content-between align-items-center mb-1">
//       <div className="d-flex align-items-center">
//         <Checkbox
//           color="primary"
//           className="mr-1"
//           disabled
//           name="type"
//           icon={<Check className="vx-icon" size={16} />}
//           defaultChecked={false}
//         />
//         <span
//           className="font-weight-bold mb-0 text-capitalize">
//           {
//             item.status
//               ? <s>{item.title}</s>
//               : item.title
//           }
//         </span>
//         {
//           item.labels && item.labels.length
//             ? item.labels.map((label, index) => {
//               return (
//                 <Chip className="ml-1 mb-0" text={label} key={index} />
//               )
//             })
//             : null
//         }
//       </div>
//       <div >
//         <Info className="ml-1" size={16} />
//         <Star className="ml-1" size={16} />
//         <Trash className="ml-1" size={16} />
//       </div>
//     </div>
//     <p className="mb-0">
//       {
//         item.status
//           ? <s>{item.description}</s>
//           : <span>{item.description}</span>
//       }
//     </p>
//   </CardBody>
// </Card>